import React from "react";

const Footer = () => {
  return (
    <>
      <footer id="footer" className="footer">
        <div className="copyright">
          &copy; Copyright 2023{" "}
          <strong>
            <span>Call Adda</span>
          </strong>
          . All Rights Reserved
        </div>
      </footer>
    </>
  );
};

export default Footer;
